import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { STORAGE_EXPIRATION_MILI_SECOND } from '../constants';

const useCleanupLocalStorage = () => {
  const location = useLocation();
  const { pathname } = location;

  useEffect(deleteOldDataFromLocalStorage, [pathname]);
};

const deleteOldDataFromLocalStorage = () => {
  const currentTimeStamp = new Date().getTime();

  for (const key in localStorage) {
    const timeDifference = currentTimeStamp - Number(key);
    if (timeDifference > STORAGE_EXPIRATION_MILI_SECOND) {
      localStorage.removeItem(key);
    }
  }
};

export const LocalStorageManager = () => {
  useCleanupLocalStorage();
  return null;
};

export default LocalStorageManager;